import { ENTER } from '../constants/EventKeys';
export default {
  tabIndex: 0,
  onKeyDown: e => e.key === ENTER && e.target.click()
};
